The success result for the `postPositionFromDraft` mutation.
